
(() => {
  const gallery = document.querySelector('[data-jinous-gallery]');
  if (!gallery) return;
  const slides = [...gallery.querySelectorAll('.jinous-slide')];
  if (slides.length < 2) return;
  const stage = gallery.querySelector('.jinous-stage');
  const toolbar = gallery.querySelector('.jinous-toolbar');
  const previous = gallery.querySelector('[data-jinous-prev]');
  const next = gallery.querySelector('[data-jinous-next]');
  const pause = gallery.querySelector('[data-jinous-pause]');
  const pauseLabel = gallery.querySelector('[data-jinous-pause-label]');
  const count = gallery.querySelector('[data-jinous-count]');
  const status = gallery.querySelector('[data-jinous-status]');
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const INTERVAL = 5000;
  let current = 0, requested = 0, request = 0, timer = null;
  let paused = false, hovering = false, focused = false;
  let visible = !('IntersectionObserver' in window), pointer = null;
  const pending = new Map();
  const wrap = value => (value + slides.length) % slides.length;
  const stop = () => { if (timer !== null) clearTimeout(timer); timer = null; };
  const canRotate = () => !paused && !hovering && !focused && !motion.matches && !document.hidden && visible;
  function schedule() {
    stop();
    if (canRotate()) timer = setTimeout(() => { timer = null; show(current + 1, true); }, INTERVAL);
  }
  function load(index) {
    if (pending.has(index)) return pending.get(index);
    const img = slides[index].querySelector('img');
    const ready = new Promise(resolve => {
      const finish = async () => {
        if (!img.naturalWidth) { resolve(false); return; }
        try { if (img.decode) await img.decode(); } catch {  }
        resolve(Boolean(img.naturalWidth));
      };
      img.addEventListener('load', finish, { once: true });
      img.addEventListener('error', () => resolve(false), { once: true });
      if (img.dataset.jinousSrc) { img.src = img.dataset.jinousSrc; delete img.dataset.jinousSrc; }
      if (img.complete) finish();
    });
    pending.set(index, ready);
    return ready;
  }
  function warmNeighbours() {
    load(wrap(current + 1));
    // Keep downloads small: only the next photograph is preloaded automatically.
  }
  async function show(value, automatic = false) {
    stop();
    const target = wrap(value), token = ++request;
    requested = target;
    const ready = await load(target);
    if (token !== request) return;
    if (automatic && !canRotate()) { requested = current; schedule(); return; }
    if (!ready) {
      requested = current;
      status.textContent = 'This image could not load. Please try another image.';
      schedule();
      return;
    }
    current = target;
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === current);
      slide.setAttribute('aria-hidden', String(i !== current));
    });
    count.textContent = `${String(current + 1).padStart(2, '0')} / ${slides.length}`;
    // Autoplay is silent; announce only a visitor's own selection.
    if (!automatic) status.textContent = `Image ${current + 1} of ${slides.length}. ${slides[current].querySelector('img').alt}`;
    warmNeighbours();
    schedule();
  }
  function updatePlayback() {
    pause.hidden = motion.matches;
    pause.dataset.paused = String(paused);
    pauseLabel.textContent = paused ? 'Play' : 'Pause';
    pause.setAttribute('aria-label', paused ? 'Start image rotation' : 'Pause image rotation');
    schedule();
  }
  previous.addEventListener('click', () => show(requested - 1));
  next.addEventListener('click', () => show(requested + 1));
  pause.addEventListener('click', () => { paused = !paused; updatePlayback(); });
  gallery.addEventListener('keydown', event => {
    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
    const keys = { ArrowLeft: requested - 1, ArrowRight: requested + 1, Home: 0, End: slides.length - 1 };
    if (Object.prototype.hasOwnProperty.call(keys, event.key)) { event.preventDefault(); show(keys[event.key]); }
  });
  gallery.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') { hovering = true; stop(); } });
  gallery.addEventListener('pointerleave', event => { if (event.pointerType !== 'touch') { hovering = false; schedule(); } });
  gallery.addEventListener('focusin', () => { focused = true; stop(); });
  gallery.addEventListener('focusout', event => { focused = gallery.contains(event.relatedTarget); schedule(); });
  stage.addEventListener('pointerdown', event => {
    if (event.pointerType === 'touch' && event.isPrimary !== false) { pointer = { id: event.pointerId, x: event.clientX, y: event.clientY }; stop(); }
  });
  stage.addEventListener('pointerup', event => {
    if (!pointer || pointer.id !== event.pointerId) return;
    const dx = event.clientX - pointer.x, dy = event.clientY - pointer.y;
    pointer = null;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) show(requested + (dx < 0 ? 1 : -1));
    else schedule();
  });
  stage.addEventListener('pointercancel', () => { pointer = null; schedule(); });
  document.addEventListener('visibilitychange', schedule);
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', schedule);
  if (motion.addEventListener) motion.addEventListener('change', updatePlayback);
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) warmNeighbours();
      schedule();
    }, { threshold: 0.2 });
    observer.observe(gallery);
  } else warmNeighbours();
  toolbar.hidden = false;
  updatePlayback();
})();
